<template>
  <!-- <el-select v-model="value" placeholder="请选择" @change="changeValue($event)" clearable >
    <el-option
      v-for="item in partys"
      :key="item.code"
      :label="item.name"
      :value="item.code"
    />
  </el-select> -->
  <el-autocomplete
    v-model="value"
    class="inline-input"
    :fetch-suggestions="querySearch"
    placeholder="请输入内容"
    style="width:100%"
    clearable
    @select="changeValue($event)"
  />
</template>
<script>
import request from '@/utils/request'
export default {
  data() {
    return {
      value: '',
      partys: [],
      callbackMethod: '',
      partyName: ''
    }
  },
  created() {
    this.findShipmentPartys()
  },
  methods: {
    findShipmentPartys() {
      request({
        url: '/ntocc-basic-api/party/wmsShipment',
        method: 'get',
        params: { name: this.partyName }
      }).then(response => {
        this.partys = response.data
      })
    },

    querySearch(queryString, callback) {  
        this.value = queryString
        var list = [{}];  
        request({
          url: '/ntocc-basic-api/party/wmsShipment',
          method: 'get',
          params: { name: queryString }
        }).then(response => {
          this.partys = response.data
        })
            .then((response)=>{  
            for(let i of this.partys){  
                i.value = i.name;
            }  
            list = this.partys;  
            callback(list);  
        }).catch((error)=>{  
        })
    },      

    changeValue(e) {
      this.$emit("setCustomerCode", e)  
    },
    setSelectValue(value) {
      if(value!=''){
        let sd = this.partys.find( i => i.code = value)
        this.value = sd.name
      }else{
        this.value = value
      } 
    },
  }
}
</script>
